import { BrowserRouter } from "react-router-dom";
import Header from "../src/Component/header/Header";
import MenuTags from "./Component/Menu/MenuTags";
import Pages from "./Pages/Pages";

  import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./store/theme";
//
//   <ThemeProvider theme={theme}>
//     <CssBaseline />
//     <App />
//   </ThemeProvider>

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Header />
        <MenuTags />
        <Pages />
      </BrowserRouter>
    </ThemeProvider>
  );
}
export default App;



// function App() {
//   return (
//     <BrowserRouter>
//       <Header />
//       <MenuTags />
//       <Pages />
//     </BrowserRouter>
//   );
// }
// export default App;
